import React, { FC, memo } from 'react'
import { useTranslate } from 'react-polyglot'
import { tokens } from '@getgo/chameleon-core/next/goto-admin'
import { AlertOutlinedIcon, CheckmarkOutlinedIcon } from '@getgo/chameleon-icons/react'
import { Typography } from '@getgo/chameleon-web-react-wrapper'
import { Box, ListItem, ListItemIcon, ListItemText, makeStyles, SvgIcon } from '@material-ui/core'
import { UserAvatar } from '@ucc/unified-admin-common'
import clsx from 'clsx'

import config from 'config'
import { Activity } from 'types/Activity'

const useStyles = makeStyles(() => ({
  failed: {
    backgroundColor: tokens.surfaceColorDangerSecondary,
  },
}))

interface ActivityListItemProps {
  activity: Activity
  locale: string
}

const ActivityListItem: FC<ActivityListItemProps> = ({ activity, locale }) => {
  const { isSuccessful, message, endTime } = activity
  const t = useTranslate()
  const author = activity.admin
  const classes = useStyles()

  // Might wanna replace this with a library later when we pick one
  const formatDate = (timestamp: number) =>
    Intl.DateTimeFormat(locale.replace('_', '-'), {
      day: 'numeric',
      month: 'long',
      hour: 'numeric',
      minute: 'numeric',
    }).format(timestamp)

  return (
    <ListItem alignItems="flex-start" className={clsx(!isSuccessful && classes.failed)}>
      <ListItemIcon>
        {author ? (
          <Box mr={2}>
            <UserAvatar
              name={`${author?.firstName} ${author?.lastName}`}
              avatarKey={author?.key}
              avatarUrl={config.AVATARS_URL}
            />
          </Box>
        ) : (
          <SvgIcon style={{ position: 'relative', top: 2 }} fontSize="small">
            {isSuccessful ? <CheckmarkOutlinedIcon /> : <AlertOutlinedIcon />}
          </SvgIcon>
        )}
      </ListItemIcon>
      <ListItemText
        primary={
          <Typography>
            {message} {author && t('by')} <b>{`${author?.firstName} ${author?.lastName}`}</b>
          </Typography>
        }
        secondary={
          <Typography variant="caption-medium" color="type-color-secondary">
            {endTime && formatDate(endTime)}{' '}
            {!isSuccessful && (
              <>
                -{' '}
                <Typography variant="caption-medium" color="type-color-danger">
                  {t('Failed')}
                </Typography>
              </>
            )}
          </Typography>
        }
      />
    </ListItem>
  )
}

export default memo(ActivityListItem)
